/**
 * Opens a <dialog> from a trigger that may sit anywhere on the page.
 *
 * Delegated from the document rather than from a wrapper element: the triggers for
 * these live inside a <legend>, which only accepts phrasing content, so the dialog
 * itself has to be emitted elsewhere in the markup. Matching on id keeps the two
 * connected without nesting one inside the other.
 */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const opener = target.closest('[data-dialog-open]');
  if (opener instanceof HTMLElement) {
    const dialog = document.getElementById(opener.dataset.dialogOpen || '');
    if (dialog instanceof HTMLDialogElement) dialog.showModal();
    return;
  }

  const closer = target.closest('[data-dialog-close]');
  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }

  // A click that lands on the dialog itself rather than on its panel is a click on
  // the backdrop.
  if (target instanceof HTMLDialogElement) target.close();
});
